export const EmptyOperators = new Set(['is_known', 'is_unknown', 'last_week', 'last_month'])
